import { CommonModule } from '@angular/common';
import {
  AfterViewChecked,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LangSelectorWrapperComponent } from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { FooterColumnComponent } from '../../features/footer-column/footer-column.component';
import { InformationComponent } from '../../features/information/information.component';
import { ContentSocialIcon } from '../../features/social-icons/models/social-icons.interfaces';
import { SocialIconsComponent } from '../../features/social-icons/social-icons.component';
import { ContentFooter } from './models/global-footer.interfaces';

@Component({
  selector: 'idp-footer-ui',
  standalone: true,
  templateUrl: './global-footer.component.html',
  styleUrls: ['./global-footer.component.scss'],
  imports: [
    SocialIconsComponent,
    InformationComponent,
    FooterColumnComponent,
    LangSelectorWrapperComponent,
    CommonModule,
    FormsModule
  ]
})
export class GlobalFooterComponent implements AfterViewChecked {
  @Input() displaySearch = true;
  @Input() trimFooter = false;
  @Input() disableLangSelection = false;
  @Input() isLightFooter = false;
  @Input() disableBackgroundColor = false;
  @Input() contentFooter = {} as ContentFooter;
  @Output() afterViewCheck = new EventEmitter();
  @Output() iconClick = new EventEmitter<ContentSocialIcon>();
  @Output() search = new EventEmitter<string>();
  @Output() searchAnalyticsEvent = new EventEmitter<{
    element: HTMLElement;
    searchTerm: string;
  }>();

  @Output() searchInputAnalyticsEvent = new EventEmitter<HTMLElement>();
  @Output() analyticsEvent = new EventEmitter<HTMLElement>();
  @ViewChild('searchButton') searchButton!: ElementRef<HTMLElement>;
  searchTerm = '';

  setTrackingEvents(e: MouseEvent): void {
    this.searchInputAnalyticsEvent.emit(e.target as HTMLElement);
  }

  iconClicked(icon: ContentSocialIcon): void {
    this.iconClick.emit(icon);
  }

  ngAfterViewChecked(): void {
    this.afterViewCheck.emit();
  }

  onClearSearch(): void {
    this.searchTerm = '';
  }

  onSearchInputFocus(event: Event): void {
    if (event?.target) {
      this.searchInputAnalyticsEvent.emit(event.target as HTMLElement);
    }
  }

  submitSearch(event?: Event): void {
    const element = event?.currentTarget || this.searchButton?.nativeElement;
    if (element) {
      this.searchAnalyticsEvent.emit({
        element: element as HTMLElement,
        searchTerm: this.searchTerm
      });
    }
    if (!this.searchTerm) return;
    this.search.emit(this.searchTerm);
  }
}
